import { SelectOption } from '@app/app/_components/Input/Select/SelectOption';
import { ReactNode, useCallback, KeyboardEvent } from 'react';
import { twJoin } from 'tailwind-merge';

interface Props {
    option: SelectOption;
    selected?: boolean;
    onClick?: (value: SelectOption) => void;
    children: ReactNode;
}

export function SelectItem({ option, children, selected, onClick }: Props) {
    const handleClick = useCallback(() => {
        onClick?.(option);
    }, [onClick, option]);

    const handleKeyDown = useCallback((e: KeyboardEvent<HTMLLIElement>) => {
        if (e.code === 'Enter') {
            e.currentTarget.click();

            e.preventDefault();
        }
    }, []);

    return (
        <li
            className={twJoin(
                'inline-flex cursor-pointer rounded px-3 py-2.5 text-sm md:py-1.25',
                selected && 'bg-primary-200',
                !selected && 'hover:bg-neutral-100',
            )}
            role="option"
            tabIndex={0}
            onKeyDown={handleKeyDown}
            onClick={handleClick}
            aria-label={option.label}
            aria-selected={selected}>
            {children}
        </li>
    );
}
